export default __webpack_public_path__ + "static/media/HomePics.4c49ec60.jpeg";